export default __webpack_public_path__ + "static/media/pantry1-afterD-480w.dc81d767.png";